import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=dcde9152&scoped=true&"
import script from "./Instructions.js?vue&type=script&lang=js&"
export * from "./Instructions.js?vue&type=script&lang=js&"
import style0 from "./Instructions.scss?vue&type=style&index=0&id=dcde9152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcde9152",
  null
  
)

export default component.exports